import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  NgLabelTemplateDirective,
  NgOptionComponent,
  NgOptionTemplateDirective,
  NgSelectComponent,
} from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { ValidatorType } from '@shared/models/enums/validator-type.enum';
import { PriorityDropdown } from '@shared/models/question-types/priority-dropdown';
import { ValidatorComponent } from '../../validator/validator.component';
import { QuestionBaseComponent } from '../question-base/question-base.component';

@Component({
  selector: 'app-priority-dropdown',
  imports: [
    NgSelectComponent,
    ReactiveFormsModule,
    NgOptionComponent,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    TranslateModule,
    QuestionBaseComponent,
    ValidatorComponent,
  ],
  templateUrl: './priority-dropdown.component.html',
  styleUrl: './priority-dropdown.component.scss',
})
export class PriorityDropdownComponent implements OnInit {
  @Input({ required: true }) question!: PriorityDropdown;
  @Input({ required: true }) form!: FormGroup;
  @Input() isFirstQuestion: boolean = false;

  dropdownStates: boolean[] = [];
  validatorType = ValidatorType;

  ngOnInit(): void {
    this.dropdownStates = new Array(this.question.rows.length).fill(false);
    this.disableAlternatives();
  }

  private getSelectedValues(): string[] {
    const formValues = Object.values(this.form.getRawValue()).filter(
      (value) => value !== null && value !== undefined,
    );
    const selectedAlternatives: string[] = [];
    this.question.rows.forEach((row) => {
      row.alternatives.forEach((alternative) => {
        if (formValues.includes(alternative.id)) {
          selectedAlternatives.push(alternative.orderNumber.toString());
        }
      });
    });

    return selectedAlternatives;
  }

  disableAlternatives() {
    const selectedValues = this.getSelectedValues();
    this.question.rows.forEach((row) => {
      row.alternatives.forEach((alternative) => {
        alternative.disabled = false;
        if (
          selectedValues.find((i) => i === alternative.orderNumber.toString())
        ) {
          alternative.disabled = true;
        }
      });
    });
  }

  handleOnChange() {
    this.disableAlternatives();
  }

  getAlternativeTitle(row: PriorityDropdown['rows'][number], alternativeId: string): string {
    return (
      row.alternatives.find((alternative) => alternative.id === alternativeId)
        ?.title ?? ''
    );
  }

  getSelectedTitle(rowId: string): string {
    const selectedValue = this.form.get(rowId)?.value;
    if (!selectedValue) {
      return '';
    }

    const row = this.question.rows.find((questionRow) => questionRow.id === rowId);
    return row?.alternatives.find((alternative) => alternative.id === selectedValue)?.title ?? '';
  }
}
